type Invert<M extends Record<keyof M, PropertyKey>> = {
  [K in keyof M as M[K]]: K;
};

export const createMappers = <
  LEFT,
  RIGHT,
  MAPPING extends Record<keyof LEFT, keyof RIGHT> = Record<
    keyof LEFT,
    keyof RIGHT
  >,
>(
  map: MAPPING,
) => {
  const invertedMap = (
    Object.entries(map) as Array<[PropertyKey, PropertyKey]>
  ).reduce(
    (inverted, [key, value]) => ({ ...inverted, [value]: key }),
    {},
  ) as Invert<MAPPING>;

  const leftToRight = (from: LEFT): RIGHT => {
    const result: Partial<RIGHT> = {};

    (Object.entries(map) as Array<[keyof LEFT, keyof RIGHT]>).forEach(
      ([leftKey, rightKey]) => {
        (result as any)[rightKey] = (from as any)[leftKey];
      },
    );

    return result as RIGHT;
  };

  const rightToLeft = (from: RIGHT): LEFT => {
    const result: Partial<LEFT> = {};

    (Object.entries(invertedMap) as Array<[keyof RIGHT, keyof LEFT]>).forEach(
      ([rightKey, leftKey]) => {
        (result as any)[leftKey] = (from as any)[rightKey];
      },
    );

    return result as LEFT;
  };

  return [leftToRight, rightToLeft] as const;
};
